import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { forgotPassword } from '../../../app/store/slices/authSlice';
import logo from '../../../assets/images/logos/576_Cash Canvas-03.png';
import { toast } from 'react-toastify';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { status } = useSelector((state) => state.auth);

  const handleSubmit = async (e) => {
    e.preventDefault();


    try {
      await dispatch(forgotPassword(email)).unwrap();

      toast.success('OTP sent to your email! Check your inbox.');
      navigate('/reset-password', { state: { email } });
    } catch (err) {
      toast.error(err || 'Failed to send OTP. Please try again.');
    }
  };

  return (
    <div className="flex-1 min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="auth-ui-card">

        <div className="flex justify-center mb-4">
                      <img
                        src={logo}
                        alt="Cash Canvas Logo"
                        className="h-56 w-auto"
                      />
                    </div>


        <h2 className="txt-page-heading">
          Forgot Password
        </h2>
        <p className="p-tag-below-heading">
          Enter your Email Address and we’ll send you an OTP to reset your password.
        </p>

        <form onSubmit={handleSubmit} className="space-y-6">
          <input
            type="email"
            name="email"
            placeholder="Enter your Email"
            className="input-field"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <button
            type="submit"
            className={`
              submit-btn
            `}
            disabled={status === 'loading'}
          >
            {status === 'loading' ? 'Sending...' : 'Send Reset OTP'}
          </button>
        </form>

        <div className="mt-6 text-center text-sm space-y-2">
          <Link to="/login" className="text-blue-800 hover:text-btn-primary-hover font-medium">
            Back to Login
          </Link>
          <p className='p-tag-below-heading'>
            Don’t have an account?{' '}
            <Link to="/signup" className="text-blue-800 hover:text-btn-primary-hover font-medium">
              Sign up
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;